import { Col, Divider, Row } from 'antd';
import { useEffect, useState } from 'react';
import { COMMON, MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { UserInfo } from '../../CU-015-01/components/UserInfo';
import { StepProps } from '../props/StepProps';
import { ItemView } from './ItemView';

export const StepViewOne = ({ data, masterData }: StepProps) => {
    const [isShowAddress, setIsShowAddress] = useState<boolean>(false);

    useEffect(() => {
        if (data?.designatedAddressDiv == '99') {
            setIsShowAddress(true);
        }
    }, [data]);

    return (
        <>
            <Row className="min-w-min mb-6">
                <UserInfo userInfo={data} />
                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">自宅</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="郵便番号（ハイフンなし）"
                                value={data?.homePostalCode}
                                formatNumber={false}
                                type="postcode"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="住所"
                                value={data?.homeAddress}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <span className="content-step-form label-step-form">
                                メールアドレス１
                            </span>
                            <span className="content-step-form">
                                {data?.homeEmail01 ?? COMMON.EMPTY}
                            </span>
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="メールアドレス2（任意）"
                                value={data?.homeEmail02}
                                type="email"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="日中連絡の取れる電話番号（ハイフンなし）"
                                value={data?.homePhoneNumber01}
                                formatNumber={false}
                                type="phone"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">勤務先</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="勤務先名称"
                                value={data?.workplaceName}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="勤務先の郵便番号"
                                value={data?.workplacePostalCode}
                                type="postcode"
                                formatNumber={false}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="勤務先の所在地"
                                value={data?.workplaceAddress}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="勤務先での役職"
                                value={data?.workplaceRole}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="勤務先の電話番号（ハイフンなし）"
                                value={data?.workplacePhoneNumber01}
                                formatNumber={false}
                                type="phone"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="勤続年数"
                                value={`${data?.workplaceServiceYears ?? '0'}年${data?.workplaceServiceMonths ?? '0'}ヶ月`}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="直近の年収"
                                value={data?.annualIncome}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full">
                    <span className="content-step-form heading-step-form">送付先</span>
                    <Divider className="my-1 mb-6" />
                    <Row gutter={[0, 12]} className={`${isShowAddress ? 'mb-6' : ''}`}>
                        <Col span={24} className="pr-[12px]">
                            <ItemView
                                label="送付先区分"
                                value={data?.designatedAddressDiv}
                                labelClassName="content-step-form label-step-form"
                                options={
                                    masterData
                                        ? masterData[
                                              MASTER_CATEGORY_LIST.ADDRESSEE_DIV_CLASSIFICATION
                                          ]
                                        : []
                                }
                            />
                        </Col>
                    </Row>

                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="送付先の郵便番号（ハイフンなし）"
                                value={data?.designatedAddressPostalCode}
                                formatNumber={false}
                                type="postcode"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="送付先の住所"
                                value={data?.designatedAddress}
                                type="text"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={24} className="pr-[12px]">
                            <ItemView
                                label="送付先備考（任意）"
                                value={data?.designatedAddressNotes}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>
            </Row>
        </>
    );
};
